import angular from 'angular';

module.exports = angular.module('common.filters.duration', [])
.filter('duration', function() {
  return function(durationInMinutes) {
    durationInMinutes = parseInt(durationInMinutes);

    if (durationInMinutes < 60) {
      return `${durationInMinutes} minutes`;
    }

    let numHours = Math.round(durationInMinutes / 60);
    if (numHours < 24) {
      return `${numHours} ${numHours === 1 ? "hour" : "hours"}`;
    }

    let numDays = Math.round(durationInMinutes / 60 / 24);
    if (numDays < 7) {
      return `${numDays} ${numDays === 1 ? "day" : "days"}`;
    }

    let numWeeks = Math.round(durationInMinutes / 60 / 24 / 7);
    return `${numWeeks} ${numWeeks === 1 ? "week" : "weeks"}`;
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/filters/duration.js
 **/